<template>
  <div>
    <transition name="slide-fade">
      <SuccessMessage v-if="userMessage" :data="userMessage" />
    </transition>
    <router-view />
  </div>
</template>

<script>
import '@/scss/directory.scss';
import '@/scss/web.scss';
import SuccessMessage from '@/components/SuccessMessage';
import { apiService } from '@/utils/api/index';
import { mapGetters } from 'vuex';
export default {
  components: {
    SuccessMessage,
  },
  computed: {
    ...mapGetters(['userMessage']),
  },
  created() {
    apiService.init(process.env.VUE_APP_ROOT_API);
  },
};
</script>
